import { IServiceSettings } from '../../../../assets/configuration';
import './css/aboutandnews.css'

export const AboutAndNews = (props: { serviceSettings: IServiceSettings }) => {
    return (
        <div className="combined-container">
            <div id="news">
                <div className="app-container">
                    <div className="content-inner">
                        <div className="in-the-news-title">IN THE NEWS:</div>
                        <hr className="orange-line" />

                        <h3 className="news-title text-white">
                            <strong>Vinformatix Partners to Deliver Open, Transparent Government</strong>
                        </h3>

                        <div className="news-row">
                            <div className="news-copy">
                                <p className="news-blurb text-white">
                                    <i>here & now Platform Recognized by Bloomberg Center for Government Excellence</i>
                                </p>
                                <a href="/bloomberg" className="read-more-link">Read More...</a>
                            </div>

                            <img
                                className="news-logo"
                                src={`${props.serviceSettings.hostUrl}/images/public/gov-ex.png`}
                                alt="GovEx"
                            />
                        </div>
                    </div>
                </div>
            </div>


            <div id="about">
                <div className="app-container">
                    <div className="content-inner">
                            <div className="in-the-news-title">
                                ABOUT US:
                        </div>
                        <div>
                            <hr className="orange-line" />
                        </div>
                        
                        <p className="text-white" style={{ fontSize: "20px" }}>
                            At the intersection of communication and technology, here &
                            now&reg; was developed by software solutions provider{" "}
                            <a
                                href="https://vinformatix.com/about"
                                style={{ color: "#e98522" }}
                            >
                                Vinformatix
                            </a>{" "}
                            to overcome the communication barriers that local governments and
                            their citizens experience.
                        </p>
                        <p className="text-white" style={{ fontSize: "20px" }}>
                            Founded by industry veteran Padma Vatsavai in 2008, Vinformatix
                            brings decades of experience in software development, helping both
                            public and private industry tackle tough problems with customized,
                            user-friendly technology solutions. Since inception, Vinformatix
                            has been transforming the way businesses and government agencies
                            increase their impact and boost productivity in the digital age
                            with leading-edge technologies. Like the systems they build, the
                            Vinformatix dedicated developers are agile, flexible, responsive
                            and detail-oriented, with a passion to help their clients think
                            around corners and outside boxes.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};